import {Action} from '@ngrx/store';
import { uiActions,UI_START_LOADING,UI_STOP_LOADING} from './ui.actions';

export interface State {

    isLoading:boolean
};
export const  initialState:State = {
                    isLoading:false
};

export function uiReducer(state = initialState,action:Action){
                switch(action.type)
                {
                    case UI_START_LOADING :
                        return {
                                isLoading:true
                        }


                    case UI_STOP_LOADING:
                    return {
                              isLoading:false
                    }

                    default :{
                            return state
                    }


                }

}

export const getLoading = (state:State ) => state.isLoading;
    
